import './style.scss'
import utility from "src/utils/utility"
import { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import { AbsoluteContainer, AppSpan, Circle, CustomContainer, FlexRow, PageTitle, PageWrapper } from 'src/style'
import { IoIosArrowBack } from 'react-icons/io'
import { OutboundCalls, Product } from 'src/model'
import * as device from 'react-device-detect'
import { Filter, ServerSideTable } from 'src/component'
import { outboundApiCallsColumns, inboundApiCallsColumns, outboundApiCallsData, inboundApiCallsData } from 'src/utils/table-layout'
import helpers from 'src/utils/helpers'


const ApiCalls = () => {
    const navigate = useNavigate()
    const {API, downloadReport} = useContext(ApiContext)
    const {info: {selectedProduct, selectedApiCallTab}, setInfoProperty} = useContext(AppInfoContext)
    const [product, setProduct] = useState<Product>(selectedProduct)
    const [selectedTab, setSelectedTab] = useState('') 
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<Array<OutboundCalls>|any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [view, setView] = useState('')

    const filterDataRef = useRef<any>({})

    useEffect(() => {
        if (selectedProduct?.id && selectedTab) {
            filterDataRef.current = {}
            setProduct(selectedProduct)
            handleFetchReport()
        }
    }, [selectedProduct, selectedTab])

    useEffect(() => {
        if (!selectedTab) setSelectedTab(selectedApiCallTab || 'outbound-calls')
    }, [selectedApiCallTab])


    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const isOutboundCalls = selectedTab === 'outbound-calls'
        const fetchPayload = { 
            pageNumber, pageSize, 
            ...filterDataRef.current, 
            filter: {...filterDataRef.current.filter, productId: selectedProduct.id},
            returnMax: isDownload 
        }
        
        const response = isOutboundCalls ? 
            await API.getOutboundApiCalls(fetchPayload)
            : {data: inboundApiCallsData, total: 4}

        if (response) {
            if (isDownload) {
                return downloadReport(response, `${isOutboundCalls ? 'OUTBOUND' : 'INBOUND'}-API-CALLS_REPORT`)
            }

            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleSelectedTab (tab: string) {
        setSelectedTab(tab)
        setInfoProperty('selectedApiCallTab', tab)
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    async function handleRowAction (data: OutboundCalls) {
        await setInfoProperty('selectedApiCall', {
            ...data, 
            type: selectedTab === 'outbound-calls' ? 'outbound' : 'inbound', 
            logoUrl: product.logoUrl
        })
        navigate(`/admin/administration/product/${product?.id}/api-calls/${data.id}`)
    }

    return (
        <>
            <PageWrapper>
                <FlexRow 
                    width="auto" sizeUnit="" gap="1"
                    onClick={() => navigate(-1)}
                >
                    <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                        <IoIosArrowBack />
                    </AppSpan>
                    <Circle 
                        size="5" bgColor='#ffffff' 
                        borderColor='#EAECF0'
                        className='fixed-flex-shape'
                        style={{overflow: 'hidden'}}
                    >
                        <Circle 
                            size='4'
                            style={{overflow: 'hidden'}}
                        >
                            <img 
                                src={product?.logoUrl} 
                                className='img-covered'
                                style={{objectFit: 'contain'}} 
                            />
                        </Circle>
                    </Circle>
                    <PageTitle 
                        color='#101828' textSize='3' fontWeight="500"
                    >
                        API Calls
                    </PageTitle>
                </FlexRow>
                <CustomContainer topMargin='2.5'>
                    <CustomContainer 
                        bottomMargin='2'
                        className='scrollable-container'
                    >
                        <FlexRow
                            gap='2' height='4' alignItems='flex-start'
                            className='tab-container'
                        >
                            {
                                tabsInfo.map((item, index) => {
                                    return (
                                        <AppSpan
                                            fontWeight={device.isFirefox ? '400' : '500'}
                                            cursor='pointer'
                                            color={selectedTab === item.value ? '#0A756F' : '#667085'}
                                            onClick={() => handleSelectedTab(item.value)}
                                            key={index}
                                    >
                                            {item.label}
                                        </AppSpan>
                                    )
                                })
                            }
                            <AbsoluteContainer 
                                bottom='0' 
                                left={selectedTab === 'outbound-calls' ? '0' : '18.5'}
                            >
                                <CustomContainer
                                    width={selectedTab === 'outbound-calls' ? '16.5' : '15.6'}
                                    height='0.2' bgColor='#0A756F'
                                />
                            </AbsoluteContainer>
                        </FlexRow>
                    </CustomContainer>

                    <ServerSideTable
                        tableData={report}
                        tableColumns={selectedTab === 'outbound-calls' ? outboundApiCallsColumns(handleRowAction) : inboundApiCallsColumns(handleRowAction)} 
                        dataFetchMethod={handleFetchReport}
                        totalRows={reportData?.totalRecords}
                        customStyle
                        shouldResetPagination={resetPagination}
                        canFilter={() => setView('filter')}
                        canClear={handleClear}
                        downloadAction={() => handleFetchReport(1, 10, true)}
                    />
                </CustomContainer>
            </PageWrapper>
            { view === 'filter' &&
                <Filter
                    type='api-calls'
                    onApplyFilter={handleFetchReport}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setView('')}
                />
            }
        </>
    )
}

export default utility.routeData('administration/product/:productId/api-calls', 'API CALLS', <ApiCalls/>)

const tabsInfo = [
    {label: 'Outbound call requests', value: 'outbound-calls'},
    {label: 'inbound call requests', value: 'inbound-calls'}
]